<div class="div-panel sticky-top email-notification-settings">
    <p class="subtitle">
        Toggle automatic email notifications for each event type.
    </p>
    <div *ngIf="error$ | async as error" class="error-message" role="alert">
        {{ error }}
    </div>
</div>

<div *ngIf="loading$ | async" class="loading-state">
    <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
</div>

<table
    mat-table
    [dataSource]="(settings$ | async) ?? []"
    class="mat-elevation-z8 email-notification-settings"
>
    <ng-container matColumnDef="eventCode">
        <th mat-header-cell *matHeaderCellDef>Event type</th>
        <td mat-cell *matCellDef="let setting">
            {{ getDisplayName(setting.eventCode) }}
        </td>
    </ng-container>

    <ng-container matColumnDef="toggle">
        <th mat-header-cell *matHeaderCellDef>Automatic emails</th>
        <td mat-cell *matCellDef="let setting">
            <mat-slide-toggle
                [checked]="setting.isEnabled"
                [disabled]="(updatingEventCode$ | async) === setting.eventCode"
                (change)="toggle(setting.eventCode, $event.checked)"
            ></mat-slide-toggle>
        </td>
    </ng-container>

    <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Last updated</th>
        <td mat-cell *matCellDef="let setting">
            {{ setting.updatedAt ? (setting.updatedAt | date: "yyyy-MM-dd HH:mm:ss") : "—" }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
